module.exports = __webpack_public_path__ + "img/74.671b63c1.png";